import React from 'react';

import type { ExpandedPaymentMethod } from '../shared/types';

import { NameInput } from './components/NameInput';
import { useNameInputWrapper } from './hooks/useNameInputWrapper';

type Props = {
	disabled: boolean;
	paymentType: ExpandedPaymentMethod;
};

export function NameInputWrapper({ disabled, paymentType }: Props): React.JSX.Element {
	const { data, actions } = useNameInputWrapper(paymentType);
	return <NameInput {...data} {...actions} disabled={disabled} />;
}
